import { produce } from 'immer';

import { ShowErrorsCampaignServiceEditor } from '../../actions/campaignServiceEditor/showErrorsCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function showErrorsCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: ShowErrorsCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId, errors } = action;

        draft[editorId].errors = errors;
        draft[editorId].isOpen = true;
    });
}
